export default "__VITE_ASSET__dw_Cdl0D__"